import styled from 'styled-components';
import { FormRenderMode, QuestionStyleTypes, useFormRuntimeContext, useQuestionStyle } from '../../../form-runtime-context';
import { QuestionChoice, QuestionDisplayType } from '../contracts';

const MatrixScaleOptionWrapper = styled.div`
	width: 100%;
	cursor: pointer;
`;

const MatrixGridRowWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 5fr;
`;

const MatrixAnswerRowWrapper = styled.div<{ answerCount: number }>`
	display: grid;
	gap: 10px;
	grid-template-columns: ${props => `repeat(${props.answerCount}, 1fr)`};
	text-align: center;
`;

export interface IRenderMatrixScaleQuestionProps {
	id: string;
	options: QuestionChoice[];
	questions: string[];
	questionIds?: { name: string; id: string }[];
	questionName: string;
	displayType?: QuestionDisplayType;
}

export const RenderMatrixScaleQuestion = (props: IRenderMatrixScaleQuestionProps) => {
	const { questionName, options, questions, id, displayType = 'radio' } = props;
	const { formRenderMode, getAnswer, answerQuestion } = useFormRuntimeContext();
	const currentAnswer = getAnswer(questionName);
	const currentAnswerSelections = JSON.parse(currentAnswer?.answer?.answerJson || '{}');
	const { fontSize, fontFamily, color, fontStyle, textDecoration, fontWeight } = useQuestionStyle(QuestionStyleTypes.answer, {}, id);

	return (
		<>
			<MatrixGridRowWrapper>
				<div></div>
				<MatrixAnswerRowWrapper answerCount={options?.length}>
					{options.map(option => {
						return (
							<div style={{ flex: 2, marginTop: 'auto', marginBottom: 'auto' }}>
								<div
									style={{
										fontFamily,
										fontSize,
										color,
										textDecoration,
										fontStyle,
										margin: 0,
										fontWeight
									}}
								>
									{option.displayName}
								</div>
							</div>
						);
					})}
				</MatrixAnswerRowWrapper>
			</MatrixGridRowWrapper>
			{questions.map((question, questionIndex) => {
				return (
					<MatrixGridRowWrapper key={questionIndex}>
						<div
							style={{
								fontFamily,
								fontSize,
								color,
								textDecoration,
								fontStyle,
								margin: 0,
								fontWeight
							}}
						>
							{question}
						</div>
						<MatrixAnswerRowWrapper answerCount={options?.length}>
							{options.map((option, optionIndex) => {
								const currentChecked = currentAnswerSelections[question] === option.displayName;
								return (
									<div key={optionIndex}>
										<MatrixScaleOptionWrapper
											onClick={c => {
												if (formRenderMode === FormRenderMode.design) {
													return;
												}
												const newAnswer = { ...currentAnswerSelections };
												const checked = !currentChecked;
												if (checked) {
													newAnswer[question] = option.displayName;
												} else {
													delete newAnswer[question];
												}
												answerQuestion({
													questionName,
													answer: { ...currentAnswer?.answer, answerJson: JSON.stringify(newAnswer) }
												});
											}}
										>
											<input
												onSelect={e => e.preventDefault()}
												onChange={() => {}}
												style={{ flex: 1, marginTop: 'auto', marginBottom: 'auto', maxWidth: 20, marginLeft: 0 }}
												checked={formRenderMode !== FormRenderMode.design ? currentChecked : false}
												type={displayType}
											/>
										</MatrixScaleOptionWrapper>
									</div>
								);
							})}
						</MatrixAnswerRowWrapper>
					</MatrixGridRowWrapper>
				);
			})}
		</>
	);
};
